module.exports = {
  "country": "UK",
  "artist": "The New Seekers",
  "song": "Beg, Steal or Borrow",
  "year": "1972",
  "place": "2",
  "spotify": "0oIL0V8acWjmUDs79Uiqsz"
};